import $ from 'jquery/src/jquery'
import gsap from "gsap";
import Axios from "axios"
import SiteHeader from "../modules/site-header";
import SiteNavMobile from "../modules/site-nav-mobile";
import AnimationMagnetic from "./animation-magnetic";

export default () => {
    let typingTimer
    let doneTypingInterval = 600

    const nodeSelectors = {
        container: '[js-search-overlay="container"]',
        background: '[js-search-overlay="background"]',
        opener: '[js-search-overlay="opener"]',
        closer: '[js-search-overlay="closer"]',
        input: '[js-search-overlay="input"]',
        results: '[js-search-overlay="search-results"]',
        loader: '[js-search-overlay="loader"]',
        illustration: '[js-search-overlay="illustration"]',
    }

    const openSearchTl = gsap.timeline({
        paused: true
    });

    openSearchTl.to(document.querySelector(nodeSelectors.container), {display: 'block', duration: 0.01}, 0)
        .to(document.querySelector(nodeSelectors.container), {opacity: 1, duration: 0.01, onComplete: () => {
                $(nodeSelectors.input).focus()
            }}, 0)
        .to(document.querySelector(nodeSelectors.background), {height: '100%', duration: 0.5, ease: "power2.in"}, 0)
        .to(document.querySelector(nodeSelectors.container).querySelectorAll('.content'), {opacity: 1, duration: 0.5, ease: "power2.in"}, 0.5)

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initSearch()
    }

    $(document).on('click', '.result', closeSearchOverlay)

    function initSearch() {
        $(nodeSelectors.opener).on('click', openSearchOverlay)

        $(nodeSelectors.closer).on('click', closeSearchOverlay)

        $(nodeSelectors.input).on('input', function () {
            $(nodeSelectors.loader).fadeIn()

            clearTimeout(typingTimer)
            typingTimer = setTimeout(() => {
                let value = $(this).val()
                let url = site_data.site_url + '/wp-json/routes/v1/search?s=' + value

                if( value ) {
                    Axios.get(url, { }).then(res => {
                        $(nodeSelectors.results).html(results(res.data))
                    }).catch(err => {
                        console.log(err)
                    }).finally(() => {
                        $(nodeSelectors.loader).fadeOut()
                    })
                } else {
                    $(nodeSelectors.results).html("")
                    $(nodeSelectors.loader).fadeOut()
                }
            }, doneTypingInterval)
        })

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                closeSearchOverlay();
            }
        });
    }

    function openSearchOverlay() {
        if( !isActive() ) {
            openSearchTl.play()
            openSearchTl.restart()

            $(nodeSelectors.closer).addClass('hamburger--search-overlay-active')
            $('html, body').addClass('gl-no-scroll')
            $(nodeSelectors.illustration).addClass('illustration--animate')
            $(SiteHeader().nodeSelectors.container).addClass('site-header--search-overlay-is-active')
            $(SiteNavMobile().nodeSelectors.opener).addClass('hamburger--active')
        }
    }

    function closeSearchOverlay() {
        if( isActive() ) {
            $(nodeSelectors.closer).removeClass('hamburger--search-overlay-active')
            $(nodeSelectors.container).fadeOut(200)
            $(nodeSelectors.input).focusout()
            $('html, body').removeClass('gl-no-scroll')

            $(SiteHeader().nodeSelectors.container).removeClass('site-header--search-overlay-is-active')

            if( !SiteNavMobile().isActive() ) {
                $(SiteNavMobile().nodeSelectors.opener).removeClass('hamburger--active')
            }
        }
    }

    function isActive() {
        return $(nodeSelectors.container).is(':visible')
    }

    function results(posts = []) {
        if( posts.length ) {
            return `
                ${posts.map(item => {
                    return `
                    <div class="result ${item.type}">
                        <a href="${item.link}" target="${item.target}">
                            <span class="image"><span class="dashicons ${item.icon}"></span></span>
                            
                            <span class="text">${item.description + ' : ' + item.title}</span>
                        </a>
                    </div>`
                }).join('')}
            `
        } else {
            return `<h3 class="result">Nema rezultata</h3>`
        }
    }

    return Object.freeze({
        init,
        isActive
    })
}